import { render, staticRenderFns } from "./Duration.vue?vue&type=template&id=120661e4&"
import script from "./Duration.vue?vue&type=script&lang=js&"
export * from "./Duration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('120661e4')) {
      api.createRecord('120661e4', component.options)
    } else {
      api.reload('120661e4', component.options)
    }
    module.hot.accept("./Duration.vue?vue&type=template&id=120661e4&", function () {
      api.rerender('120661e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/sunset-drive/components/Duration.vue"
export default component.exports